import "@hotwired/turbo-rails";
import "../custom_actions";
import "../initializers";

window.Turbo.config.forms.mode = "optin";
